import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const CTAWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 130px 0 0 0;
  text-align: center;
  z-index: 3;
  @media (min-width: ${breakpoints.tablet}) {
    position: absolute;
    top: 50%;
    right: 0;
    width: auto;
    margin: 0;
    padding: 0 30px 0 0;
    transform: translate(0, -50%);
  }
`;

export default CTAWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/CTAWrapper.js